export default __webpack_public_path__ + "static/media/Fenderskydd.f578baca.jpg";